import { render, staticRenderFns } from "./AddPropertyModal.vue?vue&type=template&id=5a658bcc&scoped=true"
import script from "./AddPropertyModal.vue?vue&type=script&lang=js"
export * from "./AddPropertyModal.vue?vue&type=script&lang=js"
import style0 from "./AddPropertyModal.vue?vue&type=style&index=0&id=5a658bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a658bcc",
  null
  
)

export default component.exports